import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IPaginationPageSizeProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    usePaginationContext
} from "../../context";
import {
    getControlMeasures
} from "../../../../helpers/theme/control";
import {
    formatNumber
} from "../../../../helpers/locale/format";
import NativeSelect from "../../../nativeSelect";
import Text from "../../../text";

const PaginationPageSize: FC<IPaginationPageSizeProps> = ({
    customTheme: customThemeProp,
    options: optionsProp,
    onChange,
    style,
    title
}) => {
    const context = usePaginationContext();

    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        activeLocale,
        localize
    } = NCoreUIKitLocalize.useContext(context.customLocalize);

    const {
        container: containerDynamicStyle
    } = useStyles({
        spaces
    });

    const measures = getControlMeasures({
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        iconSizes
    });

    if(context.isCompact) {
        return null;
    }

    const label = title ?? localize("pagination-page-size");

    const options = Array.from(new Set([
        ...optionsProp ?? context.pageSizeOptions,
        context.pageSize
    ])).sort((first, second) => first - second);

    const handleChange = (value: string) => {
        const pageSize = Number(value);

        onChange?.(pageSize);

        context.onPageSizeChange(pageSize);
    };

    return <View
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        aria-label={label}
        role="group"
    >
        <Text
            customColor={colors.content.text.mid}
            variant={measures.valueVariant}
            customTheme={customTheme}
            numberOfLines={1}
        >
            {label}
        </Text>
        <NativeSelect
            customLocalize={context.customLocalize}
            data={options.map((option) => ({
                title: formatNumber({
                    locale: activeLocale,
                    value: option
                }),
                value: String(option)
            }))}
            value={String(context.pageSize)}
            customTheme={customTheme}
            onChange={handleChange}
            spreadBehaviour="free"
            size={context.size}
        />
    </View>;
};
export default PaginationPageSize;
